import { render, staticRenderFns } from "./ClipFilter.vue?vue&type=template&id=decd0ba6"
import script from "./ClipFilter.vue?vue&type=script&lang=js"
export * from "./ClipFilter.vue?vue&type=script&lang=js"
import style0 from "./ClipFilter.vue?vue&type=style&index=0&id=decd0ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
